<template>
    <div class="widget">
        <div class="content">
            <div class="monitor-top columns">
                <div class="column col-12">
                    <h1 class="monitor-name" v-if=" currentMonitor.name ">{{ currentMonitor.name }}</h1>
                    <h1 class="monitor-name" v-else>Untitled monitor</h1>

                    <p v-if="currentMonitor.id">
                        <strong>Created</strong> {{ currentMonitor.created_at | moment('from', currentTime) }}
                        <strong>Last check</strong> {{ currentMonitor.last_check | moment('from', currentTime) }}
                        <strong>Next check</strong> {{ currentMonitor.next_check | moment('from', currentTime) }}
                    </p>
                    <p v-else>
                        You are creating a new monitor, yay! Helpful information will appear here after you save the monitor!
                    </p>

                    <p style="" class="monitor-url" v-if="currentMonitor.url" v-tooltip.bottom="currentMonitor.url">
                        <i class="fa fa-link"></i> {{ currentMonitor.url | substr(0, 70) }}
                    </p>
                </div>

                <ul class="monitor-controls btn-group-block" style="text-align: right">
                    <button v-if="currentMonitor.state == 'running'" v-on:click.prevent='pauseMonitor' class="btn btn-link"><i class="fa fa-pause"></i> Pause</button>
                    <button v-else v-on:click.prevent="startMonitor()" class="btn btn-link"><i class="fa fa-play"></i> Start</button>
                    <button v-on:click.prevent="checkNow()" class="btn btn-link"><i class="fa fa-redo-alt"></i> Check now</button>
                    <button v-on:click.prevent="saveMonitor" class="save-monitor-button btn btn-success"><i class="fa fa-save"></i> Save monitor</button>
                </ul>
            </div>

            <div v-if="currentMonitor.state == 'disabled'" class="toast toast-error">
                😟 Ooops, this monitor got disabled due to many errors.
            </div>

            <ul class="checks-graph" style="display: none">
                <li
                    v-for="check in currentMonitor.checks"
                    v-bind:key="check.id"
                    v-bind:class="{ 'changed': check.changed, 'triggered': check.triggered }"
                    v-on:click="showSnapshot(check.id)"
                    :data-timestamp="check.timestamp"
                    v-tooltip.top="{content: `
                    <img class='website-screenshot' src='${imageHost}/${check.id}-thumbnail.png'>
                    <ul>
                        <li>Time: ${check.timestamp}</li>
                        <li>Page status code: ${check.response_http_status}</li>
                        <li>Changed: ${check.changed}</li>
                        <li>Notificators triggered: ${check.triggered}</li>
                    </ul>
                    `, classes: 'checks-tooltip'}"
                ></li>
            </ul>

            <ul class="tab tab-block">
                <li 
                    v-for="(tab, index) in tabs"
                    v-bind:key="index"
                    class="tab-item">
                    <a 
                        v-on:click.prevent="setTab(index)" 
                        v-bind:class="{ active: index == currentTab }"
                        href="#" v-html="tab"></a>
                </li>
            </ul>

            <div v-if="currentMonitor">
                <form class="edit-monitor form-horizontal">
                    <div v-if="currentTab == 'general'">
                        <section class="well">
                            <h3>General information</h3>
                            <div class="form-group">
                                <label class="form-label" for="name">Name</label>
                                <input 
                                    class="form-input" 
                                    name="name" 
                                    placeholder="The name of this monitor"
                                    type="text" v-model="currentMonitor.name" id="name">
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="name">URL</label>
                                <input placeholder="https://..." class="form-input" v-validate="{ required: true, url: true }" name="url" type="text" v-model="currentMonitor.url" id="url">
                                <span v-show="errors.has('url')" class="toast toast-error">{{ errors.first('url') }}</span>
                            </div>
                        </section>
                        <section class="well">
                            <p>Scope</p>
                            <Toggles 
                                :values="selectorEnabledText" 
                                :selected="isSelectorEnabled" 
                                @update:selected="val => isSelectorEnabled = val" 
                                default=""></Toggles>

                            <div v-if="isSelectorEnabled">
                                <label class="form-label" for="number">CSS Selector</label>
                                <div class="input-group">
                                    <input type="text" v-model="currentMonitor.css_selector" id="css_path" class="form-input" style="">
                                    <button v-on:click.prevent="invokeDOMViewer()" class="btn btn-primary input-group-btn">DOM Selector</button>
                                </div>
                            </div>

                        </section>

                        <section class="well">
                            <p>Choose a preferd location from which to monitor.</p>
                            <Toggles 
                                :values="locationSelectorText" 
                                :selected="location" 
                                @update:selected="val => location = val" 
                                default=""></Toggles>
                        </section>


                        <section class="well">
                            <p>Select when to stop monitoring.</p>
                            <Toggles 
                                :values="stopOnText" 
                                :selected="StopOnChange" 
                                @update:selected="val => StopOnChange = val" 
                                default=""></Toggles>
                        </section>
                    </div> <!-- general tab -->

                    <div v-if="currentTab == 'triggers'">
                        <div class="keywords">
                            <h3 class="">Keywords</h3>
                            <p>Test if the page contains keywords, you can check for missing or existing keywords as well as specifying your own Regular Expression if you want more, greater control.</p>
                            <ul class="columns">
                                <li v-for="(item, index) in currentMonitor.keywords" v-bind:key="index" class="column col-12">
                                    <div class="input-group ">
                                        <select 
                                            :tabindex="index + 1"
                                            class="form-select select-sm" 
                                            v-model="currentMonitor.keywords[index].action">
                                            <option value="exists">Exists</option>
                                            <option value="missing">Missing</option>
                                            <option value="exists">Regex</option>
                                        </select>
                                        <input 
                                            class="form-input input-sm"
                                            style=""
                                            :tabindex="index + 1" 
                                            v-model="currentMonitor.keywords[index].value" 
                                            type="text" /> 

                                        <button 
                                            v-on:click.prevent="deleteKeyword(index)" 
                                            class="btn btn-primary btn-sm input-group-btn"><i class="fal fa-times"></i></button>
                                    </div>
                                </li>
                            </ul>

                            
                            <p>
                            <label class="form-switch" v-if="currentMonitor.keywords.length">
                                <input type="checkbox" v-model="currentMonitor.keywords_partial">
                                <i class="form-icon"></i> Trigger when any of the above keywords matches.
                            </label>
                            </p>

                            <button class="btn btn-primary btn-lg btn-block" v-on:click.prevent="addKeywordInput"><i class="fa fa-plus"></i> Add Keyword</button>
                        </div>

                        <section class="well">
                            <h3>Numeric content</h3>
                            <p>In case the content is detected to be numeric, you can specify numeral bassed triggers.</p>

                            <p>If content is numeric and is > than 10 [percent]</p>
                        </section>
                    </div> <!-- triggers tab -->
                        <div v-if="currentTab == 'actions'">
                        <div class="keywords">
                            <h3>Pre Actions</h3>
                            <p>Pre-actions are a set of actions that the spy can take before doing anything else.</p>
                            <ul class="pre-actions-list">
                                <li v-for="(item, index) in currentMonitor.pre_actions" v-bind:key="index" class="">
                                    <div class="input-group ">
                                        <select class="form-select select-sm" v-model="currentMonitor.pre_actions[index].action">
                                            <option value="click" selected="selected">Click</option>
                                            <option value="type">Type</option>
                                            <option value="remove">Remove element</option>
                                        </select>
                                        <input 
                                            class="form-input input-sm"
                                            style="display: block"
                                            :tabindex="index + 1" 
                                            v-model="currentMonitor.pre_actions[index].value" 
                                            type="text" /> 

                                        <button 
                                            v-on:click.prevent="deletePreAction(index)" 
                                            class="btn btn-primary btn-sm input-group-btn"><i class="fal fa-times"></i></button>
                                    </div>
                                </li>
                            </ul>

                            <button class="btn btn-primary btn-lg btn-block" v-on:click.prevent="addPreAction"><i class="fa fa-plus"></i> Add Pre-action</button>
                        </div>
                    </div> <!-- actions tab -->

                    <div v-if="currentTab == 'scheduling'">
                        <div class="well">
                            <h3>Interval</h3>
                            <p>
                                Scheduling allows you to choose specifically at which times and at which intervals to run checks. If you're not sure, or timing is not really necesarry you can leave this on automated and the system would choose the best schedule to run the checks for you.
                            </p>
                            <div class="columns">
                                <div class="column col-2">
                                    <input type="number" v-model="currentMonitor.interval" id="interval" class="form-input" style="">
                                </div>
                                <div class="column col-4">
                                    <select v-model="currentMonitor.interval_unit" class="form-select">
                                        <option value="m">Minutes</option>
                                        <option value="h">Hours</option>
                                        <option value="d">Days</option>
                                        <option value="w">Weeks</option>
                                        <option value="M">Months</option>
                                        <option value="y">Years</option>
                                    </select>
                                </div>

                            </div>

                            <p>Schedule</p>
                            <div class="">
                                <select v-model="startHour" class="form-select">
                                    <option v-for="hour in hours" v-bind:key="hour">{{ hour }}</option>
                                </select>

                                <select v-model="endHour" class="form-select">
                                    <option v-for="hour in hours" v-bind:key="hour">{{ hour }}</option>
                                </select>
                            </div>

                            <div class="" style="text-align: center; margin-top: 20px;">
                                <p>This would limit the monitor to check only on the specified days.</p>
                                <Toggles :values="weekdaysText" :selected="currentMonitor.selected_days" @update:selected="val => currentMonitor.selected_days = val" default="" multiple=""></Toggles>
                            </div>


                            <select v-model="currentMonitor.timezone" class="form-select">
                                <option 
                                    v-for="(timezone, index) in timeZonesList" 
                                    v-bind:key="index">{{timezone}}</option>
                            </select>
                        </div>
                        

                        <p class="scheduling-explanation">Run the check every <strong>{{ currentMonitor.interval }} {{ intervalUnit }}</strong> between <strong>{{ startHour }}</strong> and <strong>{{ endHour }}</strong> <span v-html="selectedWeekdaysText"></span>.</p>
                    </div> <!-- scheduling tab -->


                </form>
            </div>

            <div v-show="currentTab == 'notificators'" class="widget">
                <div class="header" style="overflow: hidden;">
                    <h3 class="float-left">Select notificators</h3>
                    <button class="btn float-right" v-on:click.prevent="invokeNotificatorEditorModal()">Create notificator</button>
                </div>
                <div class="content notificators-list">
                    <Notificators
                        v-for="notificator in notificators"
                        v-bind:key="notificator.id"
                        :notificator="notificator"
                        :selectedNotificators="currentMonitor.selected_notificators"
                        v-on:click.native="toggleNotificator(notificator.id)">
                    </Notificators>

                </div>
                    <section v-if="notificators.length == 0" class="empty">
                        <div class="empty-icon">
                            <i class="icon icon-people"></i>
                            <img width="80px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/speaking-head-in-silhouette_1f5e3.png" />
                        </div>
                        <p class="empty-title h5">Hmmm, you need some notificators</p>
                        <p class="empty-subtitle">Please create at least one notificator. Notificators are used when a monitor is triggered when a change is detected to notify you of said changes.</p>
                        <div class="empty-action">
                            <button class="btn btn-primary">Create notificator</button>
                        </div>
                    </section>
            </div>
        </div>

        <table class="table table-striped table-hover checks-table" v-if="currentMonitor.checks">
            <thead>
                <tr>
                    <th>Snapshot</th>
                    <th>Timestamp</th>
                    <th>HTTP Status</th>
                    <th>Changed</th>
                    <th>Triggered</th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    v-for="check in currentMonitor.checks"
                    v-bind:key="check.id"
                    class="">
                    <td>
                        <div 

                            v-on:click="showSnapshotModal(check.id)"
                            v-if="check.with_snapshot" class="snapshot" v-lazy:background-image='imageHost + "/" + check.id + "-thumbnail.png"'></div>
                        <div v-else>
                            <img width="30px" height="30px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/eyes_1f440.png" />
                        </div>
                    </td>
                    <td>{{ check.timestamp | moment('from', currentTime) }} </td>
                    <td>{{ check.response_http_status }}</td>
                    <td>
                        <img v-if="check.changed" width="30px" height="30px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/thumbs-up-sign_1f44d.png" />
                        <img v-else width="30px" height="30px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/thumbs-down-sign_1f44e.png" />
                    </td>
                    <td>
                        <img v-if="check.triggered" width="30px" height="30px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/thumbs-up-sign_1f44d.png" />
                        <img v-else width="30px" height="30px" src="https://emojipedia-us.s3.amazonaws.com/thumbs/240/apple/129/thumbs-down-sign_1f44e.png" />
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="DOMViewerVisible" class="monitor-element-selector">
            <div v-if="getDOMViewerRequest.CheckID">
                <img v-lazy="imageHost + '/temp-' + getDOMViewerRequest.CheckID + '.png?buster'" />
                <div class="elements-view">
                    <ul class="elements-list">
                        <li 
                            v-for="(element, index) in getDOMViewerRequest.Elements" 
                            v-on:click.prevent="DOMViewerSelectElement(element)"
                            :style="computePosition(element)" 
                            v-bind:key="index">
                        </li>
                    </ul>
                </div>
                <div class="toolbar">
                    <input type="text" :value="DOMViewerSelectedElement" class="selected-element" />
                    <button v-on:click.prevent="getSelectedDOMElement(DOMViewerSelectedElement)" class="btn btn-default">Done</button>
                    <button v-on:click.prevent="hideDOMViewer()" class="btn btn-default">Cancel</button>
                </div>
            </div>
            <div v-else class="loading-state">
                <p><img class="" width="120px" height="120px" src="https://s3.amazonaws.com/pagespy/loading.svg" /></p>
                <p>Loading the website viewer.</p>
            </div>
        </div>


        <NotificatorModal></NotificatorModal>
        <SnapshotModal></SnapshotModal>
    </div>
</template>

<script>
import API from "../api"
import Toggles from "../components/Toggles.vue"
import Notificators from "../components/Notificators.vue"
import NotificatorModal from "./NotificatorModal.vue"
import SnapshotModal from "./SnapshotModal.vue"
import moment from "moment-timezone"

import { mapGetters, mapActions } from 'vuex'

export default {
    props: ["id"],

    name: 'monitor-form',
    components: {
        Toggles, Notificators, NotificatorModal, SnapshotModal
    },
    data() {
        return {
            checks: [],

            currentTab: "general",
            tabs: {
                general: "<i class='fal fa-globe'></i> General",
                triggers: "<i class='fal fa-filter'></i> Triggers",
                actions: "<i class='fal fa-toggle-on'></i> Actions",
                scheduling: "<i class='fal fa-calendar'></i> Scheduling",
                notificators: "<i class='fal fa-bullhorn'></i> Notificators",
            },

            DOMViewerVisible: false,
            DOMViewerSelectedElement: false,
            DOMViewerLoaded: false,
            // DOMViewerRequest: $store.getters.getDOMViewerRequest(),
            notificators: [],
            hours: _.range(0, 24),
            currentMonitor: {
                id: null,
                type: "any_change",
                interval_unit: "d",
                interval: 1,
                pre_actions: [],
                keywords: [],
                selected_days: [0, 1, 2, 3, 4, 5, 6],
                selected_hours: [0,23],
                selected_notificators: [],
                timezone:  moment.tz.guess(),
            },
            location: false,
            locationSelectorText: {
                "Europe": "europe",
                "North America": "na",
                "South-east Asia": "asia-se",
            },
            stopOnText: {
                "On change": true,
                "Never": false
            },
            isSelectorEnabledState: false,
            isEntirePage: false,
            selectorEnabledText: {
                '<i class="far fa-file"></i> Entire Page': false,
                '<i class="far fa-crosshairs"></i> Element': true,
            },
            isType: 'any_change',
            typeText: {
                '<i class="far fa-dot-circle"></i> Any Change': 'any_change',
                '<i class="far fa-plus-square"></i> Keywords Exists': 'keywords_exist',
                '<i class="far fa-minus-square"></i> Keywords Missing': 'keywords_missing',
            },
            weekdaysText: {
                'Sunday': 0,
                'Monday': 1,
                'Tuesday': 2,
                'Wednesday': 3,
                'Thursday': 4,
                'Friday': 5,
                'Saturday': 6,
            },
            weekdaysTextInverse: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            timeZonesList: moment.tz.names()
        }
    },
    created() {

        // console.log("passed monitor:", this.props.monitor);
        //this.$store.dispatch('getMonitor', {id: this.id})
        /*
        this.monitor = 
        this.fetchMonitorByID(this.id)
        */
        this.fetchNotificators(this.$route.params.id)
       if(this.id) {

        this.$store.dispatch("getMonitor", { id: this.$route.params.id }).then(() => {
            console.log("before ", this.currentMonitor);
            // this.currentMonitor = this.$store.getters.getMonitor(this.$route.params.id)
            this.currentMonitor = this.getMonitor(this.$route.params.id)
            console.log("after ", this.currentMonitor);
        })
       }

    },
    mounted() {},
    updated() {},
    watch: {
        'currentMonitor.type': function(val) {
            console.log(val);
        },
        'currentMonitor.interval': function(val) {
            if(this.currentMonitor) {
                this.currentMonitor.interval = parseInt(val)
            }
        },
        '$route': function() {
            this.fetchMonitorByID(this.id)
            this.fetchNotificators()
        },
    },
    computed: {
        ...mapGetters({
            getMonitor: 'getMonitor',
            getDOMViewerRequest: 'getDOMViewerRequest',
            currentTime: 'currentTime'
        }),
        selectedHours() {
            return [this.startHour, this.endHour]
        },
        startHour: {
          get() {
            return this.currentMonitor.selected_hours.length ? this.currentMonitor.selected_hours[0] : 0
          },
          set(val) {
            this.currentMonitor.selected_hours[0] = parseInt(val)
          }
        },
        endHour: {
          get() {
            return this.currentMonitor.selected_hours.length ? this.currentMonitor.selected_hours[1] : 23
          },
          set(val) {
            this.currentMonitor.selected_hours[1] = parseInt(val)
          }
        },
        isSelectorEnabled: {
          get() {
            // if the css_selector contains stuff
            return ((!_.isUndefined(this.currentMonitor.css_selector) &&  this.currentMonitor.css_selector.length) || this.isSelectorEnabledState) ? true : false;
          },
          set(value) {
            console.log('previous isSelectorEnabledState', this.isSelectorEnabledState)
            // clicked the entire page button
            if(value == false) {
              // delete the previously set
              this.currentMonitor.css_selector = '';
              this.isSelectorEnabledState = false;
            } else {
              this.isSelectorEnabledState = true;
            }
            console.log('previous isSelectorEnabledState', this.currentMonitor.isSelectorEnabledState)
          },
        },
        StopOnChange: {
          get() {
            console.log("StopOnChange", this.currentMonitor.stop_on_change);
            return this.currentMonitor.stop_on_change
          },
          set(val) {
            console.log("StopOnChange", this.currentMonitor.stop_on_change);
            console.log("StopOnChange val", val);
            this.currentMonitor.stop_on_change = (val == 'true')
          }
        },
        intervalUnit: {
            get() {
                var units = {
                    "m": "minute",
                    "h": "hour",
                    "d": "day",
                    "w": "week",
                    "M": "month",
                    "y": "year",
                }
                let text = units[this.currentMonitor.interval_unit];

                return this.currentMonitor.interval == 1 ? text : text + "s";
            }
        },
        selectedWeekdaysText: {
            get() {
                let text = "";
                let weekdays = [];
                if(this.currentMonitor.selected_days.length == 7) {
                    text = "on all days of the week";
                } else {
                    window._.each(this.currentMonitor.selected_days, (k, i) => {
                        weekdays.push("<strong>" + this.weekdaysTextInverse[k] + "</strong>")
                    })

                    text = weekdays.slice(0, -1).join(", ") + " and " + weekdays.slice(-1);
                }


                return text;
            }
        }
    },
    methods: {
        setTab(index) {
            this.currentTab = index
            console.log(this.tabs);
            console.log(index);
            console.log(this.tabs[index]);
        },
        computePosition (element) {
            // var image_size  = 1264.8,
            //     viewport_size = 1366,
            //     ratio = (viewport_size - image_size) / image_size

            var ratio = 1;


            return {
                width: element.box.width * ratio + "px",
                height: element.box.height * ratio + "px",
                top: element.box.y * ratio + "px",
                left: element.box.x * ratio + "px"
                // selector: el
            }
        },
        fetchNotificators () {
            var that = this
            API.get(`/notificators`).then(function (response) {
                if(response.data.OK) {
                    that.notificators = response.data.Notificators
                }
            })
        },
        showToast () {
            this.$toasted.show('hola billo')
            this.$toasted.info('hola billo')
            this.$toasted.success('hola billo')
            this.$toasted.error('some info thing', {
                action: [
                    { text: 'Cancel', onClick: (e, toastObject) => { toastObject.goAway(0) } },
                    { text: 'Undo', onClick: (e, toastObject) => { this.$router.push({ name: 'somewhere' }) } }
                ]
            })
        },
        fetchMonitorByID (id) {
            if (id) {
                var that = this
                API.monitors.findByID(id).then(monitor => {
                    that.currentMonitor = monitor.data
                })
            }
        },
        // save the check boyyy
        // there's PATCH that allows for partial resource updates
        // there's PUT that updates the whole resource
        // there's POST that creates a new resource
        async saveMonitor (event) {
            // this.currentMonitor.Interval = parseInt(this.currentMonitor.Interval);

            var self = this;

            await this.$store.dispatch('save', this.currentMonitor).then(response => {
                // if there was no ID before, it means that we just created a new monitor
                if(!self.currentMonitor.id) {
                  this.$router.push({ path: `/monitors/${response.data.id}` })
                    this.$toasted.success('New monitor created').goAway(2000)
                } else {
                    this.$toasted.success('Monitor saved!').goAway(2000)
                }
            }).catch(error => {
                console.log(error)
                this.$toasted.error('Could not save your monitor').goAway(2000)
            })


/*
            console.info(this.currentMonitor)

            if (this.currentMonitor.id) {
                API.monitors.Update(this.currentMonitor).then(response => {
                  this.$toasted.success('Check was succesfully updated!').goAway(2000)
                })
            } else {
                // TODO: try and do this using watchers, atm it seems they dont like me
                API.monitors.Save(this.currentMonitor).then(response => {
                  this.$router.push({ path: `/monitors/${response.data.id}` })
                })
            }
*/
        },
        addPreAction() {
            const emptyAction = {
                action: "click",
                value: ""
            }

            if(_.isArray(this.currentMonitor.pre_actions)) {
                // this.currentMonitor.pre_actions.push(_.extend(emptyAction, this.currentMonitor.pre_actions))
                this.currentMonitor.pre_actions.push(emptyAction)
            } else {
                this.currentMonitor.pre_actions = []
            }
        },
        deletePreAction(index) {
            this.currentMonitor.pre_actions.splice(index, 1);
        },
        addKeywordInput() {
            const emptyKeyword = {
                action: "exists",
                value: ""
            }
            if(_.isArray(this.currentMonitor.keywords)) {
                // this.currentMonitor.keywords.push(_.extend('', this.currentMonitor.keywords))
                this.currentMonitor.keywords.push(emptyKeyword)
            } else {
                this.currentMonitor.keywords = []
            }
        },
        deleteKeyword(index) {
            this.currentMonitor.keywords.splice(index, 1);
        },
        startMonitor() {
            this.currentMonitor.state = 'running'
            API.monitors.Start(this.currentMonitor).then(response => {
              this.$toasted.success('Monitor started succesfully.').goAway(2000)
            })
        },
        checkNow() {
            API.monitors.Spy(this.currentMonitor.id).then(response => {
              this.$toasted.success('Check requested succesfully').goAway(2000)
            }).catch(err => {
              this.$toasted.error('Could not trigger check').goAway(2000)
            })
        },
        pauseMonitor() {
            this.currentMonitor.state = 'stopped'
            API.monitors.Pause(this.currentMonitor).then(response => {
              this.$toasted.success('Monitor stopped succesfully.').goAway(2000)
            })
        },
        toggleNotificator(id) {
            if(!_.isArray(this.currentMonitor.selected_notificators)) {
                this.currentMonitor.selected_notificators = []
            }

            if(_.includes(this.currentMonitor.selected_notificators, id)){
                this.currentMonitor.selected_notificators.splice(this.currentMonitor.selected_notificators.indexOf(id), 1)
            } else {
                this.currentMonitor.selected_notificators.push(id)
            }

            // this.saveMonitor();
        },

        invokeNotificatorEditorModal() {
          this.$modal.show('notificator-editor');
        },

        showSnapshotModal(id) {
          this.$modal.show('snapshot-modal', {check_id: id});
        },

        invokeDOMViewer() {
            this.DOMViewerLoaded = false;
            this.DOMViewerVisible = true;

            // remove previously set requests
            this.$store.commit("CLEAR_DOM_VIEWER_REQUEST")

            this.$http.post('dom', {url: this.currentMonitor.url}).then(response => {
                // this.DOMViewerLoaded = true;
            })
        },
        hideDOMViewer() {
            this.DOMViewerVisible = false;
        },
        DOMViewerSelectElement(element) {
            console.log(element);
            this.DOMViewerSelectedElement = element.selector
        },
        getSelectedDOMElement(element) {
            this.currentMonitor.css_selector = element;
            this.DOMViewerVisible = false;
            this.DOMViewerLoaded = false;
        }
    },
}
</script>

<style lang="scss">
.monitor-element-selector {
    background: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;


    div.loading-state {
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        width: 100%;
        height: 100%;
        border-radius: 5px;
        text-align: center;
    }

    img {
        width: 100%;
        border-radius: 5px;
    }

    .elements-view {
        position: absolute;
        top: 0;
        left: 0;

        .elements-list {
            li {
                position: absolute;
                margin: 0;
                padding: 0;
                list-style: none;

                &:hover {
                    background: rgba(208, 245, 108, 0.3);
                    border: 1px solid rgba(54, 115, 39, 0.211);
                    border-radius: 2px;
                }
            }
        }
    }

    .toolbar {
        position: sticky;
        bottom: 0px;
        left: 0px;
        background: #f7f7f7;
        border-top: 1px solid #000000;
        width: 100%;
        margin: 0 auto;
        padding: 15px;
        background-image: linear-gradient(to bottom, #303649 0%, #141a2b 100%);
        border-radius: 0;
        color: #fff;

        input {
            width: 79%;
            border: 1px solid #000;
            padding: 10px;
            border-radius: 5px;
            box-shadow: 1px 1px 10px #abafbd inset, 0px 1px 0px #616c8c;
            font-family: monospace;
            font-size: 13px;
        }

        p {
            display: inline-block;
            float: left;
        }
    }
}

.scheduling-explanation {
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    margin: 20px 0;

    strong {
        font-weight: 800;
    }
}

.monitor-top {
    margin-bottom: 10px;

    h1.monitor-name {
        margin: 0;
        padding: 0;
        color: #303649;
        font-weight: 300;
    }

    p {
        margin: 0;
        font-weight: 300;
    }

    p.monitor-url {
        color: #889cb1;
        padding: 0;
        margin: 0;
        font-size: 14px;
        text-overflow: ellipsis;
        display: inline-block;
    }

    .monitor-controls {
        position: absolute;
        top: 10px;
        right: 10px;

      .btn {
        box-shadow: none;

        &.save-monitor-button {
            text-shadow: 0px 1px 1px #156720;
            font-weight: bold;
        }

        &.btn-link {
            color: #b9c4e8;
            font-weight: 300;
            font-size: 15px;

            &:hover {
                color: #008bd2;
            }
        }
      }
    }
}

.well {
    padding: 30px;
    margin-bottom: 20px;
    border: 1px solid #f4f6f8;

    &.with-background {
        background: #f8f9fa;
        border: none;
    }
}

form.edit-monitor {
    box-shadow: none;
    border: none;

    input[type=text] {
        margin: 0;
        width: 100%;
    }

    .url-form-input input {
        padding: 23px 15px;
        font-size: 18px;
        font-weight: 300;
    }

    .form-label {
        font-size: 14px;
    }

    .form-group {
        padding: 10px;
    }

    .keywords {
        transition: all 0.2s;
        @extend .well;

        h3 {
            display: block;
        }

        p {
            display: block;
        }

        input {
            border: 1px solid #d2d2d2;

            &:hover {
                border: 1px solid #00a9ff;
            }
        }

        button.monitors-keywords__button-add {
            width: 100%;

            &:hover {
                box-shadow: 2px 3px 10px rgba(0, 169, 255, 0.27);
            }
        }

        ul {
            margin: 0;
            padding: 0;
            display: block;
            width: 100%;

            li {
                list-style: none;
                display: block;
                width: 100%;
            }
        }

        .keywords-partial-toggle {
            text-align: center;
            padding: 12px 68px;
            margin: 0;
        }
    }

    .button-group {
        margin: 0;
        transition: all 0.2s;
        border: none;

        button {
            background: #fff;
            border: 1px solid #fff;
            border-radius: 2px;
            margin: 2px;

            &:hover {
                background: linear-gradient(to bottom, #d7e7f7 30%, #ffffff 100%);
                color: #000;
                border-radius: 2px;
                border-color: #eee;
            }

            &.button-selected {
                background: #00a9ff;
                color: #fff;
                transition: all 0.2s;
                text-shadow: 0px 1px 1px #000;
                border: 1px solid #008bd2;
            }
        }

        &.weekdays-button-group {
            font-size: 12px;
        }
    }

    .row {
        margin: 10px 0;
    }
}

.save-monitor-button {
    &:hover {
        background: #7ba716;
    }

    &:focus {
        background: #8bbd17;
        box-shadow: 0px 0px 27px rgba(139, 189, 23, 0.38);
    }
}

.notificators-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    // grid-auto-rows:  minmax(69px, auto);
}

.checks-table {
    .snapshot {
        width: 100px;
        height: 100px;
        background-repeat: no-repeat;
    }
}

</style>




// WEBPACK FOOTER //
// src/components/MonitorForm.vue